import { configLog } from 'rcd-cpp-logger';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createStore } from 'redux';
import { createApi } from './api';
import reducers from './elements/contentPlan/store';
import { StandaloneApp } from './components/App/app';
import './index.scss';
import { enhancers } from './utils/middleware';
import { getToken } from './utils/authClient';
import { RefreshOverlay } from './components/App/SessionExpiry/sessionExpiry';
import { Toasters } from './components/Toaster/toasters';

configLog(console);

const configStore = () => {
  return createStore(reducers, enhancers);
};

const App = () => {
  const [showVpnError, setShowVpnError] = React.useState(false);
  const getAPI = () => createApi({ getToken, setShowVpnError });
  return (
    <>
      <StandaloneApp elFn={{ getAPI }} />
      <Toasters />
      {showVpnError && (
        <RefreshOverlay>
          The server is not reachable. Please check VPN connectivity.
        </RefreshOverlay>
      )}
    </>
  );
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <App />
  }
]);

ReactDom.render(
  <Provider store={configStore()}>
    <DndProvider backend={HTML5Backend}>
      <RouterProvider router={router} />
    </DndProvider>
  </Provider>,
  document.getElementById('app')
);
